/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_Price_SuffixInputs */



/**
* | output |
* | --- |
* | "+ pay-per-use" |
*
* @param {Gateway_Card_Price_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_price_suffix = /** @type {((inputs?: Gateway_Card_Price_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_Price_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("+ nutzungsabhängig")
	return /** @type {LocalizedString} */ ("+ pay-per-use")
});